export default __webpack_public_path__ + "static/media/theme3net.227cc300.png";